import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSite } from '../../data/SiteContext';
import { isAdminAuthed, signOutWithApi, clearAuth } from '../../data/adminAuth';
import { setSessionExpiredHandler } from '../../data/api';
import { NAV, TITLES, pillStyle, AVAILABILITY_LABEL, AVAILABILITY_ORDER } from './adminData';
import { toBody } from '../../data/SiteContext';
import { apiUpload } from '../../data/api';
import EntityEditor, { FIELDS, emptyEntity } from './EntityEditor';
import { initialsOf } from './initials';
import logo from '../../assets/images/hola-caribe-logo.svg';
import Dashboard from './Dashboard';
import Hotels from './Hotels';
import DestinationForm from './DestinationForm';
import Settings from './Settings';

// Small header with an "+ Add" button for a list screen.
function ListHeader({ label, onAdd }) {
  return (
    <div style={{ display:'flex', alignItems:'center', marginBottom:14 }}>
      <div style={{ fontSize:13.5, color:'#5a726f', fontWeight:600 }}>{label}</div>
      <span onClick={onAdd} className="a-primary" style={{ marginLeft:'auto', padding:'11px 18px', borderRadius:12, fontSize:13.5, cursor:'pointer' }}>+ Add</span>
    </div>
  );
}

const panel = { padding:'6px 22px 14px', borderRadius:22, overflowX:'auto' };

function DestinationsSection({ dests, nd, setNd, addDest, delDest, onEdit, onAddFull }) {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);

  const onCover = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    setError(null);
    try {
      const { fileId, url } = await apiUpload(file);
      setNd({ ...nd, coverImageFileId: fileId, coverImageUrl: url });
    } catch (err) {
      setError(err.message || 'Upload failed.');
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  };

  const submit = async () => {
    if (!nd.name.trim()) return;
    setError(null);
    try {
      await addDest(nd);
      setNd({ name:'', country:'', from:'' });
    } catch (err) { setError(err.message || 'Could not add the destination.'); }
  };
  return (
    <div style={{ display:'grid', gap:18 }}>
      <div className="glass-card" style={{ padding:24, borderRadius:22 }}>
        <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:16 }}>
          <div style={{ fontWeight:800, fontSize:16 }}>Add a destination</div>
          <span onClick={onAddFull} style={{ marginLeft:'auto', cursor:'pointer', fontSize:13, fontWeight:800, color:'#0e8a9c' }}>Open full form →</span>
        </div>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(150px,1fr))', gap:12, alignItems:'end' }}>
          <label style={{ display:'block' }}><span className="a-label">Name</span><input value={nd.name} onChange={e => setNd({ ...nd, name:e.target.value })} placeholder="e.g. Tulum" className="a-input" style={{ padding:'12px 13px' }} /></label>
          <label style={{ display:'block' }}><span className="a-label">Country</span><input value={nd.country} onChange={e => setNd({ ...nd, country:e.target.value })} placeholder="e.g. Mexico" className="a-input" style={{ padding:'12px 13px' }} /></label>
          <label style={{ display:'block' }}><span className="a-label">Price from ($)</span><input value={nd.from} onChange={e => setNd({ ...nd, from:e.target.value })} placeholder="899" className="a-input" style={{ padding:'12px 13px' }} /></label>
          <label style={{ display:'block', cursor:'pointer' }}>
            <span className="a-label">Cover image</span>
            <div style={{ padding:'11px 13px', borderRadius:13, border:'1px dashed rgba(14,138,122,0.4)', background: nd.coverImageUrl ? `url(${nd.coverImageUrl}) center/cover` : 'rgba(255,255,255,0.6)', fontSize:13, color: nd.coverImageUrl ? 'transparent' : '#5a726f', fontWeight:600, textAlign:'center', minHeight:20 }}>
              {uploading ? 'Uploading…' : nd.coverImageUrl ? 'Selected' : 'Upload…'}
            </div>
            <input type="file" accept="image/*" onChange={onCover} style={{ display:'none' }} />
          </label>
          <button onClick={submit} className="a-primary" style={{ padding:'13px 20px', borderRadius:13, fontSize:14 }}>+ Add</button>
        </div>
        {error && <div style={{ marginTop:12, fontSize:13, color:'#c0492f', fontWeight:700 }}>{error}</div>}
      </div>
      <div className="glass-card" style={panel}>
        {dests.length > 0 ? (
          <table className="a-table" style={{ minWidth:600, marginTop:8 }}>
            <thead><tr><th>Destination</th><th>Country</th><th>Type</th><th>Nights</th><th>From</th><th></th></tr></thead>
            <tbody>
              {dests.map(d => (
                <tr key={d.id}>
                  <td><div style={{ display:'flex', alignItems:'center', gap:11 }}><div style={{ width:40, height:32, borderRadius:9, flexShrink:0, backgroundImage:`url(${d.img})`, backgroundSize:'cover', backgroundPosition:'center' }}></div><span style={{ fontWeight:800 }}>{d.name}</span></div></td>
                  <td style={{ color:'#5a726f' }}>{d.country}</td>
                  <td><span style={{ padding:'5px 11px', borderRadius:100, background:'rgba(14,138,122,0.12)', color:'#0c6d7c', fontSize:11.5, fontWeight:800 }}>{d.tag}</span></td>
                  <td>{d.nights}</td>
                  <td style={{ fontWeight:800 }}>${d.from}</td>
                  <td style={{ textAlign:'right', whiteSpace:'nowrap' }}>
                    <span onClick={() => onEdit(d.id)} style={{ cursor:'pointer', color:'#0e8a9c', fontWeight:800, fontSize:13, padding:'6px 10px', borderRadius:8 }}>Edit</span>
                    <span onClick={() => delDest(d.id)} style={{ cursor:'pointer', color:'#c0492f', fontWeight:800, fontSize:13, padding:'6px 10px', borderRadius:8 }}>Delete</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div style={{ padding:'56px 24px 62px', textAlign:'center' }}>
            <div style={{ width:74, height:74, borderRadius:24, margin:'0 auto 18px', background:'rgba(14,138,122,0.1)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:30 }}>🗺</div>
            <div className="serif" style={{ fontSize:24, marginBottom:8 }}>No destinations yet</div>
            <div style={{ fontSize:14.5, color:'#5a726f', maxWidth:'38ch', margin:'0 auto 22px', lineHeight:1.6 }}>Add your first destination and it will appear on the public site straight away.</div>
            <span onClick={onAddFull} className="a-primary" style={{ display:'inline-block', padding:'13px 26px', borderRadius:13, fontSize:14 }}>+ Add destination</span>
          </div>
        )}
      </div>
    </div>
  );
}

function BookingsSection({ bookings, cycleBooking, onDelete }) {
  const [q, setQ] = useState('');
  const [statusF, setStatusF] = useState('All statuses');
  const shown = bookings.filter(b => {
    if (statusF !== 'All statuses' && b.status !== statusF) return false;
    if (q.trim()) {
      const n = q.toLowerCase();
      return (b.name || '').toLowerCase().includes(n) || (b.ref || '').toLowerCase().includes(n) || (b.dest || '').toLowerCase().includes(n) || (b.email || '').toLowerCase().includes(n);
    }
    return true;
  });
  return (
    <div style={{ display:'grid', gap:16 }}>
      <div className="glass" style={{ display:'flex', alignItems:'center', gap:10, flexWrap:'wrap', padding:'16px 20px', borderRadius:18 }}>
        <input value={q} onChange={e => setQ(e.target.value)} placeholder="Search ref, name, email or destination…" className="a-input" style={{ flex:1, minWidth:180, padding:'11px 14px' }} />
        <select value={statusF} onChange={e => setStatusF(e.target.value)} className="a-input" style={{ width:'auto', padding:'11px 14px' }}><option>All statuses</option><option>New</option><option>Pending</option><option>Confirmed</option></select>
        <span style={{ fontSize:13, color:'#5a726f', fontWeight:700, marginLeft:'auto' }}>{shown.length} of {bookings.length}</span>
      </div>
      <div className="glass-card" style={panel}>
        {shown.length > 0 ? (
        <table className="a-table" style={{ minWidth:720, marginTop:8 }}>
          <thead><tr><th>Ref</th><th>Name</th><th>Contact</th><th>Destination</th><th>Received</th><th>Status</th><th></th></tr></thead>
          <tbody>
            {shown.map(b => (
              <tr key={b.id}>
                <td style={{ fontWeight:800, color:'#0e8a9c' }}>{b.ref}</td>
                <td style={{ fontWeight:600 }}>{b.name}</td>
                <td style={{ color:'#5a726f' }}>{b.email || b.phone || '—'}</td>
                <td style={{ color:'#5a726f' }}>{b.dest}</td>
                <td>{b.date}</td>
                <td><span onClick={() => cycleBooking(b.id)} style={{ ...pillStyle(b.status), cursor:'pointer' }}>{b.status}</span></td>
                <td style={{ textAlign:'right' }}><span onClick={() => onDelete(b.id)} style={{ cursor:'pointer', color:'#c0492f', fontWeight:800, fontSize:13 }}>Delete</span></td>
              </tr>
            ))}
          </tbody>
        </table>
        ) : (
          <div style={{ padding:'48px 24px', textAlign:'center', color:'#5a726f' }}>No inquiries {bookings.length ? 'match your filters' : 'yet'}.</div>
        )}
      </div>
      <div style={{ fontSize:12.5, color:'#5a726f' }}>Tip: click any status pill to cycle New → Pending → Confirmed.</div>
    </div>
  );
}

export default function AdminApp() {
  const navigate = useNavigate();
  const { dests, tours, cruises, events, countryGuides, posts, testimonials, banners, addDest, delDest, setDestAvailability, bookings, cycleBooking, delInquiry, saveEntity, deleteEntity, toggleField, loadInquiries, media, setMedia, loadMedia, delMedia, me, loadMe } = useSite();
  const [screen, setScreen] = useState('dash');
  const [editId, setEditId] = useState(null);
  const [collapsed, setCollapsed] = useState(window.innerWidth < 1000);
  const [nd, setNd] = useState({ name:'', country:'', from:'' });
  const [editor, setEditor] = useState(null); // { kind, entity|null }
  const [mediaBusy, setMediaBusy] = useState(false);
  const [mediaError, setMediaError] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(null);   // the media item awaiting confirmation
  const [availError, setAvailError] = useState(null);

  const onMedia = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setMediaBusy(true);
    setMediaError(null);
    try {
      const { fileId, url } = await apiUpload(file);
      // Show it immediately; the library reloads from the API on the next visit.
      setMedia(m => [{ fileId, name: file.name, contentType: file.type, size: file.size, url, createdAt: new Date().toISOString() }, ...m]);
    } catch (err) {
      setMediaError(err.message || 'Upload failed.');
    } finally {
      setMediaBusy(false);
      e.target.value = '';
    }
  };

  const openAdd = (kind) => setEditor({ kind, entity: { ...emptyEntity[kind] } });
  const openEdit = (kind, entity) => setEditor({ kind, entity });
  const saveFromEditor = (values) => saveEntity(editor.kind, editor.entity?.id ?? null, toBody[editor.kind](values));

  useEffect(() => {
    if (!isAdminAuthed()) navigate('/admin/login', { replace: true });
  }, [navigate]);

  useEffect(() => { loadMe(); }, [loadMe]);

  // Inquiries arrive from the public site while the panel is open, so refetch whenever a
  // screen that shows them is opened — otherwise new leads stay invisible until a reload.
  useEffect(() => {
    if (screen !== 'bookings' && screen !== 'dash') return;
    loadInquiries();
  }, [screen, loadInquiries]);

  useEffect(() => {
    if (screen !== 'media') return;
    setMediaError(null);
    loadMedia().catch(e => setMediaError(e.message || 'Could not load the media library.'));
  }, [screen, loadMedia]);

  useEffect(() => {
    setSessionExpiredHandler(() => { clearAuth(); navigate('/admin/login?expired=1', { replace: true }); });
    return () => setSessionExpiredHandler(() => {});
  }, [navigate]);

  useEffect(() => {
    const onResize = () => setCollapsed(window.innerWidth < 1000);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  if (!isAdminAuthed()) return null;

  const signOut = () => { signOutWithApi(); navigate('/admin/login', { replace: true }); };
  const go = (k) => { setScreen(k); setEditId(null); };
  const wide = !collapsed;
  const t = screen === 'form' && editId
    ? ['Edit destination', TITLES.form[1]]
    : TITLES[screen] || TITLES.dash;

  // Tier prices are derived from the destination's "from" price; availability is a real field.
  const pricing = dests.map(d => ({
    id: d.id, name: d.name, std: d.from, prem: d.from + 420, lux: d.from + 890,
    avail: d.availability || 'Good',
  }));

  const cycleAvailability = async (id, current) => {
    const next = AVAILABILITY_ORDER[(AVAILABILITY_ORDER.indexOf(current) + 1) % AVAILABILITY_ORDER.length];
    try { await setDestAvailability(id, next); }
    catch (e) { setAvailError(e.message || 'Could not update availability.'); }
  };

  return (
    <div className="admin-bg" style={{ display:'flex', minHeight:'100vh' }}>
      {/* Sidebar */}
      <aside style={{ width: wide ? 250 : 78, flexShrink:0, background:'linear-gradient(180deg,#0c2b2f,#04222a)', padding:'20px 14px', display:'flex', flexDirection:'column', position:'sticky', top:0, height:'100vh', overflowY:'auto' }}>
        <div style={{ display:'flex', alignItems:'center', gap:11, padding:'6px 8px 22px' }}>
          <img src={logo} alt="HolaCaribe" style={{ flexShrink:0, height: wide ? 58 : 44, display:'block' }} />
          {wide && <div style={{ fontSize:10.5, fontWeight:800, letterSpacing:'.22em', color:'rgba(255,255,255,0.5)', alignSelf:'flex-end', paddingBottom:4 }}>ADMIN</div>}
        </div>
        <nav style={{ display:'grid', gap:3, flex:1, alignContent:'start' }}>
          {NAV.map(n => {
            const on = screen === n.k || (n.k === 'dest' && screen === 'form');
            return (
              <span key={n.k} className={'a-nav' + (on ? ' active' : '')} onClick={() => go(n.k)}>
                <span style={{ width:20, textAlign:'center', flexShrink:0 }}>{n.icon}</span>
                {wide && <span>{n.label}</span>}
              </span>
            );
          })}
        </nav>
        <div style={{ display:'grid', gap:8, paddingTop:14, borderTop:'1px solid rgba(255,255,255,0.12)' }}>
          <span onClick={() => setCollapsed(c => !c)} style={{ cursor:'pointer', padding:11, borderRadius:12, fontWeight:700, fontSize:12.5, color:'rgba(255,255,255,0.7)', background:'rgba(255,255,255,0.07)', textAlign:'center' }}>{wide ? '⟨ Collapse sidebar' : '⟩'}</span>
          <span onClick={() => navigate('/')} style={{ cursor:'pointer', padding:11, borderRadius:12, fontWeight:700, fontSize:13, color:'#fff', background:'rgba(255,255,255,0.12)', textAlign:'center', whiteSpace:'nowrap', overflow:'hidden' }}>{wide ? '← View live site' : '←'}</span>
          <span onClick={signOut} style={{ cursor:'pointer', padding:11, borderRadius:12, fontWeight:700, fontSize:13, color:'rgba(255,255,255,0.7)', background:'transparent', textAlign:'center' }}>{wide ? 'Sign out' : '⏻'}</span>
        </div>
      </aside>

      {/* Main */}
      <main style={{ flex:1, minWidth:0 }}>
        <div className="glass-bar" style={{ position:'sticky', top:0, zIndex:30, display:'flex', alignItems:'center', gap:16, padding:'16px 26px' }}>
          <div style={{ minWidth:0 }}>
            <div className="serif" style={{ fontSize:25, lineHeight:1.1 }}>{t[0]}</div>
            <div style={{ fontSize:13, color:'#5a726f' }}>{t[1]}</div>
          </div>
          <div style={{ marginLeft:'auto', display:'flex', alignItems:'center', gap:12 }}>
            <input placeholder="Search…" className="a-input" style={{ padding:'11px 15px', width:200 }} />
            <div title={me?.email || ''} style={{ width:40, height:40, borderRadius:'50%', background:'linear-gradient(140deg,#26c6a3,#0e8a9c)', color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:800, fontSize:14, boxShadow:'0 6px 16px rgba(14,138,156,0.3)' }}>{initialsOf(me?.name, me?.email)}</div>
          </div>
        </div>

        <div style={{ padding:26 }}>
          {screen === 'dash' && <Dashboard />}

          {screen === 'dest' && (
            <DestinationsSection
              dests={dests} nd={nd} setNd={setNd} addDest={addDest} delDest={delDest}
              onEdit={(id) => { setEditId(id); setScreen('form'); }}
              onAddFull={() => { setEditId(null); setScreen('form'); }}
            />
          )}

          {screen === 'form' && <DestinationForm editId={editId} onBack={() => go('dest')} />}

          {screen === 'hotels' && <Hotels />}

          {screen === 'tours' && (
            <div>
              <ListHeader label={`${tours.length} tours`} onAdd={() => openAdd('tours')} />
              <div className="glass-card" style={panel}>
                <table className="a-table" style={{ minWidth:620, marginTop:8 }}>
                  <thead><tr><th>Tour</th><th>Location</th><th>Duration</th><th>Price</th><th>Status</th><th></th></tr></thead>
                  <tbody>
                    {tours.map(x => (
                      <tr key={x.id}>
                        <td style={{ fontWeight:800 }}>{x.name}</td>
                        <td style={{ color:'#5a726f' }}>{x.place}</td>
                        <td>{x.dur}</td>
                        <td style={{ fontWeight:800 }}>${x.price}</td>
                        <td><span onClick={() => toggleField('tours', x, { isActive: !x.isActive })} style={{ ...pillStyle(x.isActive ? 'Active' : 'Draft'), cursor:'pointer' }}>{x.isActive ? 'Active' : 'Hidden'}</span></td>
                        <td style={{ textAlign:'right', whiteSpace:'nowrap' }}>
                          <span onClick={() => openEdit('tours', x)} style={{ cursor:'pointer', color:'#0e8a9c', fontWeight:800, fontSize:13, padding:'6px 10px' }}>Edit</span>
                          <span onClick={() => deleteEntity('tours', x.id)} style={{ cursor:'pointer', color:'#c0492f', fontWeight:800, fontSize:13, padding:'6px 10px' }}>Delete</span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {screen === 'cruises' && (
            <div>
              <ListHeader label={`${cruises.length} cruises`} onAdd={() => openAdd('cruises')} />
              <div className="glass-card" style={panel}>
                <table className="a-table" style={{ minWidth:620, marginTop:8 }}>
                  <thead><tr><th>Cruise</th><th>Area</th><th>Length</th><th>From</th><th>Status</th><th></th></tr></thead>
                  <tbody>
                    {cruises.map(x => (
                      <tr key={x.id}>
                        <td style={{ fontWeight:800 }}>{x.name}</td>
                        <td style={{ color:'#5a726f' }}>{x.area}</td>
                        <td>{x.nights}</td>
                        <td style={{ fontWeight:800 }}>${(x.from || 0).toLocaleString('en-US')}</td>
                        <td><span onClick={() => toggleField('cruises', x, { isActive: !x.isActive })} style={{ ...pillStyle(x.isActive ? 'Active' : 'Draft'), cursor:'pointer' }}>{x.isActive ? 'Active' : 'Hidden'}</span></td>
                        <td style={{ textAlign:'right', whiteSpace:'nowrap' }}>
                          <span onClick={() => openEdit('cruises', x)} style={{ cursor:'pointer', color:'#0e8a9c', fontWeight:800, fontSize:13, padding:'6px 10px' }}>Edit</span>
                          <span onClick={() => deleteEntity('cruises', x.id)} style={{ cursor:'pointer', color:'#c0492f', fontWeight:800, fontSize:13, padding:'6px 10px' }}>Delete</span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {screen === 'events' && (
            <div>
              <ListHeader label={`${events.length} events`} onAdd={() => openAdd('events')} />
              <div className="glass-card" style={panel}>
                <table className="a-table" style={{ minWidth:680, marginTop:8 }}>
                  <thead><tr><th>Event</th><th>Place</th><th>When</th><th>Sources</th><th>Status</th><th></th></tr></thead>
                  <tbody>
                    {events.map(x => {
                      const nSources = (x.sources || '').split('\n').map(s => s.trim()).filter(Boolean).length;
                      return (
                        <tr key={x.id}>
                          <td style={{ fontWeight:800 }}>{x.name}</td>
                          <td style={{ color:'#5a726f' }}>{x.place}</td>
                          <td>{x.when}</td>
                          <td>{nSources > 0
                            ? <span title={x.sources} style={{ fontSize:12.5, fontWeight:800, color:'#0e8a9c' }}>{nSources} source{nSources > 1 ? 's' : ''}</span>
                            : <span style={{ fontSize:12.5, fontWeight:800, color:'#c0492f' }}>None</span>}</td>
                          <td><span onClick={() => toggleField('events', x, { isActive: !x.isActive })} style={{ ...pillStyle(x.isActive ? 'Active' : 'Draft'), cursor:'pointer' }}>{x.isActive ? 'Active' : 'Hidden'}</span></td>
                          <td style={{ textAlign:'right', whiteSpace:'nowrap' }}>
                            <span onClick={() => openEdit('events', x)} style={{ cursor:'pointer', color:'#0e8a9c', fontWeight:800, fontSize:13, padding:'6px 10px' }}>Edit</span>
                            <span onClick={() => deleteEntity('events', x.id)} style={{ cursor:'pointer', color:'#c0492f', fontWeight:800, fontSize:13, padding:'6px 10px' }}>Delete</span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {screen === 'countryGuides' && (
            <div>
              <ListHeader label={`${countryGuides.length} country guides`} onAdd={() => openAdd('countryGuides')} />
              <div className="glass-card" style={panel}>
                <table className="a-table" style={{ minWidth:620, marginTop:8 }}>
                  <thead><tr><th>Country</th><th>Key</th><th>Sources</th><th>Status</th><th></th></tr></thead>
                  <tbody>
                    {countryGuides.map(x => {
                      const nSources = (x.sources || '').split('\n').map(s => s.trim()).filter(Boolean).length;
                      return (
                        <tr key={x.id}>
                          <td style={{ fontWeight:800 }}>{x.countryName}</td>
                          <td style={{ color:'#5a726f' }}>{x.key}</td>
                          <td>{nSources > 0
                            ? <span title={x.sources} style={{ fontSize:12.5, fontWeight:800, color:'#0e8a9c' }}>{nSources} source{nSources > 1 ? 's' : ''}</span>
                            : <span style={{ fontSize:12.5, fontWeight:800, color:'#c0492f' }}>None</span>}</td>
                          <td><span onClick={() => toggleField('countryGuides', x, { isActive: !x.isActive })} style={{ ...pillStyle(x.isActive ? 'Active' : 'Draft'), cursor:'pointer' }}>{x.isActive ? 'Active' : 'Hidden'}</span></td>
                          <td style={{ textAlign:'right', whiteSpace:'nowrap' }}>
                            <span onClick={() => openEdit('countryGuides', x)} style={{ cursor:'pointer', color:'#0e8a9c', fontWeight:800, fontSize:13, padding:'6px 10px' }}>Edit</span>
                            <span onClick={() => deleteEntity('countryGuides', x.id)} style={{ cursor:'pointer', color:'#c0492f', fontWeight:800, fontSize:13, padding:'6px 10px' }}>Delete</span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {screen === 'bookings' && <BookingsSection bookings={bookings} cycleBooking={cycleBooking} onDelete={delInquiry} />}

          {screen === 'blog' && (
            <div>
              <ListHeader label={`${posts.length} posts`} onAdd={() => openAdd('posts')} />
              <div style={{ display:'grid', gap:12 }}>
                {posts.map(p => (
                  <div key={p.id} className="glass" style={{ display:'flex', alignItems:'center', gap:16, padding:'14px 18px', borderRadius:18, flexWrap:'wrap' }}>
                    <div style={{ width:92, height:64, borderRadius:12, flexShrink:0, backgroundImage:`url(${p.img})`, backgroundSize:'cover', backgroundPosition:'center' }}></div>
                    <div style={{ flex:1, minWidth:160 }}>
                      <div style={{ fontWeight:800, fontSize:15.5 }}>{p.title}</div>
                      <div style={{ fontSize:13, color:'#5a726f', marginTop:3 }}>{p.cat} · {p.date} · {p.mins} min read</div>
                    </div>
                    <span onClick={() => toggleField('posts', p, { isPublished: !p.isPublished })} style={{ ...pillStyle(p.isPublished ? 'Live' : 'Draft'), cursor:'pointer' }}>{p.isPublished ? 'Published' : 'Draft'}</span>
                    <span onClick={() => openEdit('posts', p)} style={{ cursor:'pointer', color:'#0e8a9c', fontWeight:800, fontSize:13.5, padding:'8px 14px', borderRadius:10, background:'rgba(14,138,122,0.08)' }}>Edit</span>
                    <span onClick={() => deleteEntity('posts', p.id)} style={{ cursor:'pointer', color:'#c0492f', fontWeight:800, fontSize:13.5, padding:'8px 10px' }}>Delete</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {screen === 'testi' && (
            <div>
              <ListHeader label={`${testimonials.length} testimonials`} onAdd={() => openAdd('testimonials')} />
              <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(290px,1fr))', gap:16 }}>
                {testimonials.map(r => (
                  <div key={r.id} className="glass" style={{ padding:22, borderRadius:20, opacity: r.isVisible ? 1 : 0.55 }}>
                    <div style={{ color:'#e0a13a', letterSpacing:2, fontSize:15 }}>{'★'.repeat(r.rating || 5)}</div>
                    <p style={{ fontSize:14.5, lineHeight:1.6, color:'#274044', margin:'12px 0 16px' }}>"{r.text}"</p>
                    <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                      <div style={{ width:38, height:38, borderRadius:'50%', background:'linear-gradient(140deg,#26c6a3,#0e8a9c)', color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:800, fontSize:14 }}>{r.initial}</div>
                      <div style={{ flex:1, minWidth:0 }}><div style={{ fontWeight:800, fontSize:14 }}>{r.name}</div><div style={{ fontSize:12.5, color:'#5a726f' }}>{r.trip}</div></div>
                    </div>
                    <div style={{ display:'flex', gap:8, marginTop:14, borderTop:'1px solid rgba(14,138,122,0.12)', paddingTop:12 }}>
                      <span onClick={() => openEdit('testimonials', r)} style={{ cursor:'pointer', color:'#0e8a9c', fontWeight:800, fontSize:12.5 }}>Edit</span>
                      <span onClick={() => toggleField('testimonials', r, { isVisible: !r.isVisible })} style={{ cursor:'pointer', color:'#5a726f', fontWeight:800, fontSize:12.5 }}>{r.isVisible ? 'Hide' : 'Show'}</span>
                      <span onClick={() => deleteEntity('testimonials', r.id)} style={{ marginLeft:'auto', cursor:'pointer', color:'#c0492f', fontWeight:800, fontSize:12.5 }}>Delete</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {screen === 'banners' && (
            <div>
              <ListHeader label={`${banners.length} banners`} onAdd={() => openAdd('banners')} />
              <div style={{ display:'grid', gap:14 }}>
                {banners.map(b => (
                  <div key={b.id} className="glass" style={{ display:'flex', alignItems:'center', gap:18, padding:14, borderRadius:20, flexWrap:'wrap' }}>
                    <div style={{ width:210, height:110, borderRadius:14, flexShrink:0, backgroundImage:`url(${b.img})`, backgroundSize:'cover', backgroundPosition:'center' }}></div>
                    <div style={{ flex:1, minWidth:180 }}>
                      <div className="serif" style={{ fontSize:21 }}>{b.title}</div>
                      <div style={{ fontSize:13.5, color:'#5a726f', marginTop:4 }}>{b.sub}</div>
                    </div>
                    <span style={pillStyle(b.state)}>{b.state}</span>
                    <span onClick={() => openEdit('banners', b)} style={{ cursor:'pointer', color:'#0e8a9c', fontWeight:800, fontSize:13.5, padding:'9px 15px', borderRadius:11, background:'rgba(14,138,122,0.08)' }}>Edit</span>
                    <span onClick={() => deleteEntity('banners', b.id)} style={{ cursor:'pointer', color:'#c0492f', fontWeight:800, fontSize:13.5, padding:'9px 10px' }}>Delete</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {screen === 'pricing' && (
            <div style={{ display:'grid', gap:12 }}>
              <div className="glass-card" style={panel}>
                <table className="a-table" style={{ minWidth:580, marginTop:8 }}>
                  <thead><tr><th>Destination</th><th>Standard</th><th>Premium</th><th>Luxury</th><th>Availability</th></tr></thead>
                  <tbody>
                    {pricing.map(p => (
                      <tr key={p.id}>
                        <td style={{ fontWeight:800 }}>{p.name}</td>
                        <td>${p.std}</td>
                        <td>${p.prem}</td>
                        <td>${p.lux}</td>
                        <td>
                          <span onClick={() => cycleAvailability(p.id, p.avail)} style={{ ...pillStyle(AVAILABILITY_LABEL[p.avail]), cursor:'pointer' }}>
                            {AVAILABILITY_LABEL[p.avail] || p.avail}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {availError && <div style={{ fontSize:13, color:'#c0492f', fontWeight:700 }}>{availError}</div>}
              <div style={{ fontSize:12.5, color:'#5a726f' }}>Tip: click an availability pill to cycle Good → Limited → Sold out. Tier prices are derived from each destination's "from" price.</div>
            </div>
          )}

          {screen === 'media' && (
            <div>
              <label style={{ display:'block', marginBottom:18, padding:34, borderRadius:20, border:'2px dashed rgba(14,138,122,0.35)', background:'rgba(255,255,255,0.55)', textAlign:'center', cursor:'pointer' }}>
                <div style={{ width:58, height:58, borderRadius:18, margin:'0 auto 14px', background:'rgba(14,138,122,0.1)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:24 }}>{mediaBusy ? '…' : '⬆'}</div>
                <div style={{ fontWeight:800, fontSize:16, marginBottom:5 }}>{mediaBusy ? 'Uploading…' : 'Click to upload a photo'}</div>
                <div style={{ fontSize:13.5, color:'#5a726f' }}>JPG or PNG — uploaded to the media library</div>
                <input type="file" accept="image/*" onChange={onMedia} style={{ display:'none' }} />
              </label>
              {mediaError && <div style={{ fontSize:13, color:'#c0492f', fontWeight:700, marginBottom:14 }}>{mediaError}</div>}
              {media.length > 0 ? (
                <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(165px,1fr))', gap:14 }}>
                  {media.map(m => {
                    const used = m.usedBy || [];
                    return (
                      <div key={m.fileId} className="glass" style={{ borderRadius:16, overflow:'hidden', position:'relative' }}>
                        <div style={{ height:118, backgroundColor:'rgba(14,138,122,0.06)', backgroundImage:`url(${m.url})`, backgroundSize:'cover', backgroundPosition:'center' }}></div>
                        {/* An image in use cannot be deleted — say so on the tile rather than only in the error. */}
                        <div style={{ position:'absolute', top:8, left:8, padding:'3px 9px', borderRadius:100, fontSize:10.5, fontWeight:800, letterSpacing:'.03em',
                          background: used.length ? 'rgba(14,138,156,0.92)' : 'rgba(255,255,255,0.92)', color: used.length ? '#fff' : '#5a726f' }}>
                          {used.length ? `IN USE · ${used.length}` : 'UNUSED'}
                        </div>
                        <div style={{ padding:'10px 12px' }}>
                          <div style={{ fontSize:12.5, fontWeight:700, color:'#274044', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{m.name}</div>
                          <div style={{ fontSize:11, color:'#5a726f', marginTop:2 }}>{Math.max(1, Math.round(m.size / 1024))} KB</div>
                          {used.length > 0 && (
                            <div style={{ fontSize:11, color:'#5a726f', marginTop:5, lineHeight:1.4 }}>
                              {used.slice(0, 2).map(u => `${u.entityType}: ${u.entityName}`).join(' · ')}
                              {used.length > 2 ? ` · +${used.length - 2} more` : ''}
                            </div>
                          )}
                          <span onClick={() => { setMediaError(null); setConfirmDelete(m); }}
                            style={{ display:'inline-block', marginTop:8, fontSize:12, fontWeight:800, cursor:'pointer', color: used.length ? '#5a726f' : '#c0492f' }}>
                            Delete
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="glass" style={{ padding:'52px 24px', borderRadius:20, textAlign:'center' }}>
                  <div className="serif" style={{ fontSize:23, marginBottom:8 }}>No photos yet</div>
                  <div style={{ fontSize:14.5, color:'#5a726f' }}>Upload an image above and it will appear here.</div>
                </div>
              )}
            </div>
          )}

          {confirmDelete && (
            <div onClick={() => setConfirmDelete(null)} style={{ position:'fixed', inset:0, zIndex:110, display:'flex', alignItems:'center', justifyContent:'center', padding:24, background:'rgba(6,40,45,0.45)', backdropFilter:'blur(6px)' }}>
              <div onClick={e => e.stopPropagation()} style={{ width:'100%', maxWidth:440, padding:28, borderRadius:22, background:'rgba(255,255,255,0.94)', backdropFilter:'blur(30px) saturate(180%)', border:'1px solid rgba(255,255,255,0.9)', boxShadow:'0 30px 70px rgba(6,40,45,0.35)' }}>
                <div className="serif" style={{ fontSize:23, marginBottom:10 }}>Delete this photo?</div>
                <div style={{ height:130, borderRadius:14, marginBottom:14, backgroundImage:`url(${confirmDelete.url})`, backgroundSize:'cover', backgroundPosition:'center' }}></div>
                {(confirmDelete.usedBy || []).length > 0 ? (
                  <div style={{ fontSize:14, lineHeight:1.6, color:'#0c2b2f' }}>
                    This photo is still on {(confirmDelete.usedBy || []).length === 1 ? 'a live page' : 'live pages'}. Remove it there first, or it would leave a broken image.
                    <div style={{ marginTop:10, display:'grid', gap:6 }}>
                      {(confirmDelete.usedBy || []).map((u, i) => (
                        <div key={i} style={{ padding:'9px 12px', borderRadius:11, background:'rgba(14,138,156,0.1)', fontSize:13, fontWeight:700 }}>{u.entityType}: {u.entityName}</div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div style={{ fontSize:14.5, lineHeight:1.6, color:'#0c2b2f' }}>
                    Nothing on the site uses this photo, so removing it is safe. This cannot be undone.
                  </div>
                )}
                {mediaError && <div style={{ marginTop:12, fontSize:13, fontWeight:700, color:'#c0492f' }}>{mediaError}</div>}
                <div style={{ display:'flex', gap:10, marginTop:20 }}>
                  <span onClick={() => setConfirmDelete(null)} className="a-ghost" style={{ flex:1, textAlign:'center', padding:13, borderRadius:13, fontSize:14, cursor:'pointer' }}>Cancel</span>
                  {(confirmDelete.usedBy || []).length === 0 && (
                    <button onClick={async () => {
                      try { await delMedia(confirmDelete.fileId); setConfirmDelete(null); }
                      catch (e) { setMediaError(e.message || 'Could not delete the photo.'); }
                    }} style={{ flex:1, padding:13, borderRadius:13, fontSize:14, fontWeight:800, color:'#fff', border:'none', cursor:'pointer', background:'linear-gradient(135deg,#d4593a,#c0492f)' }}>Delete photo</button>
                  )}
                </div>
              </div>
            </div>
          )}

          {screen === 'settings' && <Settings />}
        </div>
      </main>

      {editor && (
        <EntityEditor
          title={`${editor.entity?.id ? 'Edit' : 'Add'} ${editor.kind === 'posts' ? 'post' : editor.kind === 'countryGuides' ? 'country guide' : editor.kind.replace(/s$/, '')}`}
          fields={FIELDS[editor.kind]}
          initial={editor.entity}
          onSave={saveFromEditor}
          onClose={() => setEditor(null)}
        />
      )}
    </div>
  );
}
